import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../../services/document.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { AuthenticationService } from '../../../services/authentication.service';


@Component({
    selector: 'app-shared-document-detail',
    templateUrl: './shared-document-detail.component.html',
    styleUrls: ['./shared-document-detail.component.scss']
})
export class SharedDocumentDetailComponent implements OnInit {


    pagecode: string = "document";
    module: string = "home";
    accessdenied: boolean = false;

    isLoading: boolean = true;

    fileId: string = "";

    constructor(private authentication: AuthenticationService, private route: ActivatedRoute, private _router: Router, private _commonService: CommonService, private _documentsService: DocumentService) { }

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            debugger;
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        let map: any = this.route.paramMap;
                        this.fileId = map.destination._value.id;

                        this.getDocumentById();

                        window.scroll(0, 0);
                        //
                    }
                    else
                        this.accessdenied = true;
                    this.isLoading = false;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                    this.isLoading = false;
                }
            );
        });
    }
    document: any;
    getDocumentById() {
        this._documentsService.getDocumentById(this.fileId, this.authentication._authentication.userName).subscribe(
            (res: any) => {
                console.log("getDocumentById", res);
                if (res.data == null) {
                    this.accessdenied = true;
                }
                else {
                    this.document = res.data;
                    this.document.file.fileSize_mb = 0;
                    if (this.document.file.fileSize)
                        this.document.file.fileSize_mb = parseFloat((this.document.file.fileSize / 1024 / 1024).toString()).toFixed(2);
                    this.accessdenied = false;

                }
            },
            (err) => {
                console.error("getDocumentById", err);
            }
        );
    }
    downloadFile() {
        var link = document.createElement('a');
        link.href = this.document['file'].contentBase64;
        var fileName = this.document['file'].fileName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
